export default "__VITE_ASSET__Dm9fLT34__"